import {FaStar} from 'react-icons/fa'
import {MdLocationOn} from 'react-icons/md'
import {IoBagHandle} from 'react-icons/io5'

import './index.css'

const SimilarJobsSection = props => {
  const {similarJobs} = props
  return (
    <ul className="similar-jobs-container">
      {similarJobs.map(eachJob => (
        <li className="similar-job-item" key={eachJob.id}>
          <div className="logo-and-title utility-flex">
            <img
              src={eachJob.companyLogoUrl}
              alt="similar job company logo"
              className="company-logo"
            />
            <div>
              <h2>{eachJob.title}</h2>
              <div className="star-and-rating utility-flex">
                <FaStar />
                <p className="rating">{eachJob.rating}</p>
              </div>
            </div>
          </div>
          <h2 className="similar-job-description-heading">Description</h2>
          <p className="description">{eachJob.jobDescription}</p>
          <div className="location-and-employment-type utility-flex">
            <div className="location-logo-and-location utility-flex">
              <MdLocationOn />
              <p className="location">{eachJob.location}</p>
            </div>
            <div className="job-type-logo-and-job-type utility-flex">
              <IoBagHandle />
              <p className="location">{eachJob.employmentType}</p>
            </div>
          </div>
        </li>
      ))}
    </ul>
  )
}

export default SimilarJobsSection
